import { REWARD_REQUEST_STATUSES } from '@/constants';
import { RewardItemDTO, RewardRequestDisplayDTO, RewardRequestDTO, UserDTO } from '@/models';

interface RewardPeriodState {
  id: number;
  name: string;
  description: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  startDate: string;
  endDate: string;
  createdBy: UserDTO;
  rewardItems: RewardItemDTO[];
  rewardRequests: RewardRequestDTO[];
}

const initialState: RewardPeriodState = {
  id: -1,
  name: '',
  description: 'string',
  status: '',
  createdAt: '',
  updatedAt: '',
  startDate: '',
  endDate: '',
  createdBy: {} as UserDTO,
  rewardItems: [],
  rewardRequests: []
};

const getters = {
  rewardPeriod: (state: RewardPeriodState): RewardPeriodState => {
    return state;
  },
  rewardItems: (state: RewardPeriodState): RewardItemDTO[] => {
    return state.rewardItems;
  },
  rewardRequests: (state: RewardPeriodState): RewardRequestDTO[] => {
    return state.rewardRequests;
  }
};

const mutations = {
  setRewardPeriodInformation(state: RewardPeriodState, data: any): void {
    state.id = data.id;
    state.name = data.name;
    state.description = data.description;
    state.status = data.status;
    state.createdAt = data.createdAt;
    state.updatedAt = data.updatedAt;
    state.startDate = data.startDate;
    state.endDate = data.endDate;
    state.createdBy = data.createdBy;
  },
  updateRewardPeriodStatus(state: RewardPeriodState, status: string): void {
    state.status = status;
  },
  setRewardItems(state: RewardPeriodState, data: RewardItemDTO[]): void {
    state.rewardItems = data;
  },
  setRewardRequests(state: RewardPeriodState, data: RewardRequestDTO[]): void {
    state.rewardRequests = data;
  },
  addRewardItems(state: RewardPeriodState, data: RewardItemDTO[]): void {
    state.rewardItems = state.rewardItems.concat(data);
  },
  updateRewardItem(state: RewardPeriodState, data: RewardItemDTO): void {
    const rewardItem = state.rewardItems.find(item => item.id === data.id);
    if (rewardItem) {
      rewardItem.cost = data.cost;
      rewardItem.estimatedPrice = data.estimatedPrice;
      rewardItem.quantity = data.quantity;
    }
  },
  deleteRewardItem(state: RewardPeriodState, data: number): void {
    state.rewardItems = state.rewardItems.filter(item => item.id !== data);
  },
  updateRewardRequest(state: RewardPeriodState, data: RewardRequestDisplayDTO): void {
    const rewardRequest = state.rewardRequests.find(req => req.id === data.id);
    if (rewardRequest) {
      rewardRequest.actualPrice = data.actualPrice;
      rewardRequest.status = data.status;
      if (rewardRequest.status === REWARD_REQUEST_STATUSES.REJECTED.label) {
        rewardRequest.reason = data.reason;
      }
    }
  }
};

const actions = {};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
};
